import { render, staticRenderFns } from "./PopOrderCustomerModify.vue?vue&type=template&id=138513f8&scoped=true&"
import script from "./PopOrderCustomerModify.vue?vue&type=script&lang=js&"
export * from "./PopOrderCustomerModify.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderCustomerModify.vue?vue&type=style&index=0&id=138513f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138513f8",
  null
  
)

export default component.exports